(() => {
  const overlay = document.getElementById('lm-page-transition');
  if (!overlay || window.Shopify?.designMode) return;
  let timer;
  const clear = () => { overlay.classList.remove('is-active'); clearTimeout(timer); };
  window.addEventListener('pageshow', clear);
  window.addEventListener('pagehide', clear);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) clear(); });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.hasAttribute('aria-controls')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || (url.pathname === location.pathname && url.search === location.search)) return;
    // Do not intercept navigation or compete with native cart/search handlers.
    queueMicrotask(() => {
      if (event.defaultPrevented) return;
      overlay.classList.add('is-active');
      timer = setTimeout(clear, 1800);
    });
  });
})();
